import React from 'react';
import AdReviewsScore from './ad-reviews-score';
import AdReviewItem from './ad-review-item';
import { AdReviews as AdReviewsType } from '../../types/ad-reviews';
import {
    AdReviewsWrapper,
    ReviewsTitle,
    TopTips,
    ReviewsList,
} from './index.style';

export interface AdReviewsProps {
    eleId?: string;
    total: number;
    average: number;
    topTips: string;
    isMobile: boolean;
    bottomTips: string;
    adReviews: AdReviewsType;
}

const AdReviewsList: React.FC<AdReviewsProps> = ({
    eleId,
    total,
    average,
    topTips,
    isMobile,
    adReviews
}) => {
    return (
        <AdReviewsWrapper id={eleId}>
            <ReviewsTitle>Reviews ({total})</ReviewsTitle>
            <TopTips>{topTips}</TopTips>
            <AdReviewsScore total={total} average={average} isMobile={isMobile} />
            <ReviewsList>
                {adReviews.map((review) => (
                    <AdReviewItem
                        key={review.reviewerName}
                        reviewerName={review.reviewerName}
                        date={String(review.date)}
                        rating={review.rating}
                        type={review.type}
                        text={review.text}
                    />
                ))}
            </ReviewsList>
        </AdReviewsWrapper>
    );
};

export default AdReviewsList;
